<template>
    <div>
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="330px">
                <v-card>
                    <v-card-title>
                        <span
                            class="headline">
                            {{ $vuetify.lang.t('$vuetify.logoutModal.logout') }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                {{ $vuetify.lang.t('$vuetify.logoutModal.msgConfirm') }}
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            outlined
                            @click="dialog = false">
                            {{ $vuetify.lang.t('$vuetify.logoutModal.cancel') }}
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="confirm()">
                            {{ $vuetify.lang.t('$vuetify.logoutModal.confirm') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'LogoutModal',

    data () {
        return {
            dialog: false
        }
    },

    methods: {
        openModal () {
            this.dialog = true
        },

        async confirm () {
            if (await this.logoutUser()) {
                localStorage.setItem('jwt', null)
                localStorage.setItem('username', null)
                this.$router.push({ name: 'Login' }, () => {})
            }
        },

        async logoutUser () {
            await this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('logout')
            await this.$store.dispatch('setLoading', false)
            if (res && res.data && res.data.status === 'ok') {
                return true
            } else if (res && res.data && res.data.status === 'error') {
                const error = res.data.msg
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.employee.somethingWrong'),
                    text: error,
                    type: 'error'
                })
                return false
            } else {
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.employee.somethingWrong'),
                    text: this.$vuetify.lang.t('$vuetify.employee.somethingWrong'),
                    type: 'error'
                })
                return false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
